import { useApolloClient } from 'application/providers/DataProvider';
import { useAdCampaignRemove } from '@entities/adCampaign';

const useAdRemoveModalAdapter = () => {
  const client = useApolloClient();
  const [removeAdCampaign, removeAdCampaignResult] = useAdCampaignRemove();
  const adCampaignRemoveLoading = removeAdCampaignResult.loading;

  const clearAdCampaigns = () => {
    client.cache.evict({
      id: 'ROOT_QUERY',
      fieldName: 'adcampaignsPaginationQuery',
      broadcast: false,
    });
  };

  return {
    removeAdCampaign,
    adCampaignRemoveLoading,
    clearAdCampaigns,
  };
};

export default useAdRemoveModalAdapter;
